// extracted by mini-css-extract-plugin
export var maindiv = "projectTile-module--maindiv--4gWei";
export var hoverOverMe = "projectTile-module--hoverOverMe--BGFDd";
export var imgDiv = "projectTile-module--imgDiv--5yCJC";
export var midImgDiv = "projectTile-module--midImgDiv--Z0cO2";
export var img = "projectTile-module--img--rItAO";
export var sideDiv = "projectTile-module--sideDiv--7fgV4";
export var techDiv = "projectTile-module--techDiv--R84C4";
export var name = "projectTile-module--name--EuorE";
export var desc = "projectTile-module--desc--UVmd4";
export var linkDiv = "projectTile-module--linkDiv--S4ahI";
export var midLinkDiv = "projectTile-module--midLinkDiv--xkhno";
export var linkRow = "projectTile-module--linkRow--WhJk+";
export var linkBtn = "projectTile-module--linkBtn--q38iF";
export var row = "projectTile-module--row--6w64R";
export var linkText = "projectTile-module--linkText--V4tKN";
export var linkImg = "projectTile-module--linkImg--+Y9Hk";
export var techBtn = "projectTile-module--techBtn--vk8B2";
export var linkHoverOverMe = "projectTile-module--linkHoverOverMe--eRS4P";
export var techImg = "projectTile-module--techImg--XEq7v";
export var techText = "projectTile-module--techText--N6Q5O";